// Portfolio data — synced with Vedant_Bora.pdf resume

export const personalInfo = {
  name: "Vedant Bora",
  firstName: "Vedant",
  title: "Full Stack & Backend Developer",
  tagline: "Building distributed, event-driven systems.",
  email: "vedantb9850@gmail.com",
  phone: "+91 9823033829",
  linkedin: "https://in.linkedin.com/in/vedant-bora-79b73a3a0",
  github: "https://github.com/vedbora",
  website: "https://vedantbora.online",
  location: "Solapur, Maharashtra",
  resumeUrl: "/Vedant_Bora.pdf",
  avatarUrl: "/models/avatar.glb",
  photoUrl:
    "https://customer-assets.emergentagent.com/job_5e468d03-7d68-41a6-8bd9-e72cf71e6cec/artifacts/52bss20x_my%20pic.jpeg",
  shortBio:
    "Full Stack & Backend Developer skilled in Java, Spring Boot, Node.js, React.js, MySQL, and Apache Kafka — building distributed systems with real users in production.",
  longBio:
    "I'm a Full Stack & Backend Developer (Fresher) experienced in building distributed, event-driven systems with concurrent transaction processing and asynchronous data pipelines. I've built and deployed 3 production applications with real users — including an AI-powered safety platform and a high-concurrency transaction system handling 100+ simultaneous requests. Currently interning at ValueDX, Pune, building scalable backend automation pipelines. Strong foundation in DSA, system design, and software engineering — seeking a Software Engineering role on large-scale production systems.",
  introVideoUrl: "/intro-video.mp4",
  status: "seeking software engineering roles",
};

export const bootLogs = [
  { type: "banner", delay: 0 },
  { type: "info", text: "Starting VedantApplication using Java 17 on vedant-dev", delay: 300 },
  { type: "info", text: "No active profile set, falling back to default profiles: 'default'", delay: 420 },
  { type: "info", text: "Bootstrapping Spring Data JPA repositories in DEFAULT mode", delay: 540 },
  { type: "info", text: "Tomcat initialized with port(s): 8080 (http)", delay: 660 },
  { type: "info", text: "Kafka producer bound to broker @ localhost:9092", delay: 780 },
  { type: "success", text: "Loaded modules  [ java • spring-boot • kafka • react • mysql ]", delay: 920 },
  { type: "success", text: "Started VedantApplication in 2.347 seconds (JVM running)", delay: 1120 },
  { type: "ready", text: "Portfolio ready → https://vedantbora.online", delay: 1260 },
];

export const terminalLines = [
  { type: "prompt", text: "whoami", delay: 200 },
  { type: "output", text: "vedant — full stack & backend developer", delay: 320 },
  { type: "prompt", text: "curl -s https://vedantbora.online/api/profile | jq", delay: 480 },
  { type: "json", text: "{", delay: 620 },
  { type: "json", text: '  "name": "Vedant Bora",', delay: 720 },
  { type: "json", text: '  "role": "Full Stack & Backend Developer",', delay: 820 },
  { type: "json", text: '  "stack": ["Spring Boot", "React", "Kafka", "MySQL"],', delay: 920 },
  { type: "json", text: '  "shipped": 3,', delay: 1020 },
  { type: "json", text: '  "intern": "ValueDX, Pune"', delay: 1120 },
  { type: "json", text: "}", delay: 1220 },
  { type: "prompt", text: "scroll ↓  or press  ⌘ K  to explore", delay: 1380, hint: true },
];

export const heroStack = [
  "Java",
  "Spring Boot",
  "React.js",
  "Node.js",
  "Apache Kafka",
  "MySQL",
  "REST APIs",
  "System Design",
];

export const projects = [
  {
    id: 1,
    title: "ResQRide",
    subtitle: "AI-powered vehicle safety platform",
    branch: "main",
    commits: 48,
    status: "live",
    problem:
      "Vehicle emergencies need instant hospital alerts with live GPS — without manual intervention or delayed response.",
    solution:
      "Full-stack platform with 8+ production REST APIs for crash detection, emergency alerts, and hospital notification. Twilio SMS/Voice + AI auto-notifies nearest hospitals within 5 seconds of impact.",
    impact:
      "Live on web and mobile — React.js web app, React Native mobile, Razorpay payments, and Google Maps live tracking serving real users.",
    techStack: [
      "React.js",
      "Node.js",
      "Express.js",
      "MySQL",
      "Twilio",
      "Google Maps API",
      "React Native",
      "Razorpay",
    ],
    liveUrl: "https://resqride-1.onrender.com",
    githubUrl: "https://github.com/vedbora",
    period: "Jan 2026 – Mar 2026",
    accent: "cyan",
    files: ["alertService.js", "crashDetection.js", "hospitalNotify.js"],
  },
  {
    id: 2,
    title: "Wallet Transaction System",
    subtitle: "High-concurrency distributed wallet backend",
    branch: "main",
    commits: 67,
    status: "production",
    problem:
      "Wallet systems break under concurrent load — race conditions, double-spends, and inconsistent balances during peak usage.",
    solution:
      "Spring Boot backend with 10+ REST APIs (avg response under 200ms) and Apache Kafka for asynchronous, event-driven processing across distributed services.",
    impact:
      "Handles 100+ simultaneous transactions with zero data loss using ACID-compliant MySQL. 40% throughput improvement under concurrent load. Validated via 35+ Postman test cases.",
    techStack: ["Spring Boot", "Apache Kafka", "MySQL", "H2", "Postman"],
    liveUrl: "",
    githubUrl: "https://github.com/vedbora/wallet-transaction-system",
    period: "Nov 2025 – Dec 2025",
    accent: "amber",
    files: ["WalletController.java", "KafkaConsumer.java", "TransactionEntity.java"],
  },
  {
    id: 3,
    title: "WIT Boys Hostel",
    subtitle: "Full-stack hostel management system",
    branch: "main",
    commits: 71,
    status: "live",
    problem:
      "Manual hostel operations cause inefficiencies in room allocation, registrations, complaint handling, and student record-keeping.",
    solution:
      "Flask REST API backend with role-based access control (Admin/Student) and normalized MySQL schema across 5+ relational tables. React.js frontend for student and admin workflows.",
    impact:
      "Deployed system serving 200+ students — digitized room allocation, registrations, and complaint management end-to-end.",
    techStack: ["React.js", "Flask", "MySQL", "REST APIs", "RBAC"],
    liveUrl: "https://wit-boys-hostel-1.onrender.com/",
    githubUrl: "https://github.com/vedbora",
    period: "Mar 2026 – May 2026",
    accent: "emerald",
    files: ["app.py", "models.py", "routes.py"],
  },
];

export const skillGroups = [
  {
    category: "languages",
    artifact: "languages",
    icon: "Code2",
    items: ["Java", "JavaScript", "SQL", "Python"],
  },
  {
    category: "backend",
    artifact: "backend",
    icon: "Layers",
    items: [
      "Spring Boot",
      "Spring MVC",
      "Hibernate",
      "JPA",
      "Node.js",
      "Express.js",
      "Flask",
      "REST APIs",
      "Microservices",
    ],
  },
  {
    category: "frontend",
    artifact: "frontend",
    icon: "Layout",
    items: ["React.js", "React Native", "Tailwind CSS", "HTML5", "CSS3"],
  },
  {
    category: "data & messaging",
    artifact: "databases",
    icon: "Database",
    items: ["MySQL", "H2", "Apache Kafka"],
  },
  {
    category: "devops & tools",
    artifact: "tooling",
    icon: "Wrench",
    items: ["Render", "Vercel", "Git", "GitHub", "Maven", "Postman", "IntelliJ IDEA", "VS Code"],
  },
  {
    category: "fundamentals",
    artifact: "concepts",
    icon: "Cpu",
    items: [
      "DSA",
      "OOP",
      "DBMS",
      "System Design",
      "Distributed Systems",
      "Concurrency",
      "ACID Transactions",
      "Agile",
      "SDLC",
    ],
  },
];

export const experience = [
  {
    company: "ValueDX",
    role: "Software Developer Intern",
    type: "On-site · Pune, Maharashtra",
    period: "Jun 2026 – Present",
    commit: "feat: backend automation pipelines + enterprise API integration",
    points: [
      "Developed 10+ backend automation workflows integrating enterprise REST APIs, databases, and file systems — reducing manual processing time by 60%.",
      "Built end-to-end data pipelines for Excel processing, data validation, and multi-system API integration using backend technologies.",
      "Collaborated with cross-functional teams in an Agile environment to translate business requirements into scalable technical solutions, maintaining clear technical documentation throughout.",
    ],
  },
  {
    company: "JP Morgan Chase",
    role: "Software Engineering Virtual Experience",
    type: "Forage · Remote",
    period: "2025",
    commit: "feat: spring-boot rest apis + kafka integration",
    points: [
      "Developed multiple REST APIs using Spring Boot for backend services.",
      "Integrated Apache Kafka for event-driven message processing.",
      "Implemented database persistence using H2 and tested backend workflows.",
    ],
  },
  {
    company: "Amazon Web Services",
    role: "Solutions Architecture Virtual Experience",
    type: "Forage · Remote",
    period: "2025",
    commit: "feat: scalable cloud architecture design",
    points: [
      "Designed scalable architecture solutions for real-world business scenarios.",
      "Applied cloud architecture concepts: scalability, availability, fault tolerance.",
      "Developed structured backend solutions based on business requirements.",
    ],
  },
];

export const githubRepos = [
  {
    name: "wallet-transaction-system",
    description:
      "High-concurrency wallet backend with Spring Boot & Kafka. 10+ REST APIs handling 100+ simultaneous transactions with ACID-safe processing.",
    techStack: ["Java", "Spring Boot", "Kafka", "MySQL"],
    url: "https://github.com/vedbora/wallet-transaction-system",
    language: "Java",
  },
  {
    name: "ResQRide",
    description:
      "AI-powered vehicle safety platform — crash detection, Twilio emergency alerts, hospital notification, and live GPS tracking.",
    techStack: ["React.js", "Node.js", "MySQL", "Twilio", "React Native"],
    url: "https://github.com/vedbora",
    language: "JavaScript",
  },
  {
    name: "wit-boys-hostel",
    description:
      "Full-stack hostel management for 200+ students — Flask REST API, RBAC, room allocation, and complaint management.",
    techStack: ["React.js", "Flask", "MySQL"],
    url: "https://github.com/vedbora",
    language: "Python",
  },
];

export const resumeHighlights = {
  education: {
    institution: "Walchand Institute of Technology, Solapur",
    degree: "B.Tech, Information Technology",
    cgpa: "8.0",
    year: "2027",
    period: "2023 – 2027",
  },
  certifications: [
    {
      name: "TCS NQT (National Qualifier Test)",
      issuer: "Tata Consultancy Services · Score: 1947/3000",
      year: "2026",
    },
    {
      name: "Solutions Architecture Virtual Experience",
      issuer: "Amazon Web Services (Forage)",
      year: "2025",
    },
    {
      name: "Software Engineering Virtual Experience",
      issuer: "JP Morgan Chase (Forage)",
      year: "2025",
    },
    {
      name: "Software Engineer Intern",
      issuer: "HackerRank",
      year: "2025",
    },
    {
      name: "Java (Basic)",
      issuer: "HackerRank",
      year: "2025",
    },
  ],
  quickStats: [
    { label: "Production apps shipped", value: "3" },
    { label: "Concurrent TXs handled", value: "100+" },
    { label: "REST APIs built", value: "25+" },
    { label: "CGPA", value: "8.0" },
  ],
};

export const archNodes = [
  { id: "client", label: "Client", sub: "Web / Mobile", x: 5, y: 50, type: "client" },
  { id: "gateway", label: "API Gateway", sub: "REST Layer", x: 25, y: 50, type: "service" },
  { id: "auth", label: "Auth Service", sub: "JWT + RBAC", x: 50, y: 18, type: "service" },
  { id: "wallet", label: "Core Service", sub: "Spring Boot", x: 50, y: 50, type: "service" },
  { id: "notify", label: "Automation", sub: "Async Worker", x: 50, y: 82, type: "service" },
  { id: "kafka", label: "Apache Kafka", sub: "Event Bus", x: 72, y: 50, type: "broker" },
  { id: "mysql", label: "MySQL", sub: "Primary DB", x: 92, y: 30, type: "db" },
  { id: "cache", label: "In-Memory", sub: "H2 / Cache", x: 92, y: 70, type: "db" },
];

export const archEdges = [
  { from: "client", to: "gateway" },
  { from: "gateway", to: "auth" },
  { from: "gateway", to: "wallet" },
  { from: "gateway", to: "notify" },
  { from: "wallet", to: "kafka" },
  { from: "notify", to: "kafka" },
  { from: "kafka", to: "mysql" },
  { from: "kafka", to: "cache" },
];

export const navLinks = [
  { label: "About", href: "#about", hint: "a" },
  { label: "System", href: "#system", hint: "s" },
  { label: "Projects", href: "#projects", hint: "p" },
  { label: "Skills", href: "#skills", hint: "k" },
  { label: "Experience", href: "#experience", hint: "e" },
  { label: "GitHub", href: "#github", hint: "g" },
  { label: "Contact", href: "#contact", hint: "c" },
];
